import axios from "../../utils/axios";

export const getVideos = async (tags, search, pageNo, author = "") => {
  let queryString = "";
  let pagination = "";

  if (tags?.length > 0) {
    queryString += tags.map((tag) => `tags_like=${tag}`).join("&");
  }

  if (search !== "") {
    queryString += `&q=${search}`;
  }

  if (pageNo > 0) {
    pagination = `_page=${pageNo || 1}&_limit=3`;
  } else {
    pagination = ``;
  }

  if (author !== "") {
    queryString += `&q=${author}`;
  }

  const response = await axios.get(`/videos/?${pagination}${queryString}`);

  return response.data;
};

export const likeVideoCount = async (id, payload) => {
  return await axios.put(`/videos/${id}`, payload);
};

export const unlikeVideoCount = async (id, payload) => {
  return await axios.put(`/videos/${id}`, payload);
};
